import axios from "axios";
import { customFetch } from "../lib/network/Axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { NewsSupplier } from "../types/supplier.types";
import config from "../config";

const BASE_URL = config.apiBaseUrl;

export const fetchNewsSuppliers = createAsyncThunk(
	"supplier/fetch",
	async () => {
		try {
			const response = customFetch.get(BASE_URL + "/supplier?category=NEWS");
			return response;
		} catch (err) {
			console.log(err);
		}
	},
);
